import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../../store/hooks";

import { Image } from "antd";
import { selectSkinEntities, selectSkinIds } from "../../../../store/roblox/skinsSlice";
import { selectUserEntities } from "../../../../store/roblox/usersSlice";

import Card from "./_Card";

const _ListGrid = () => {
  const ids           = useAppSelector(selectSkinIds);
  const skins  = useAppSelector(selectSkinEntities);
  const users = useAppSelector(selectUserEntities);

  const renderSticker = (id: EntityId) => {
    const skin = skins[id];

    if (!skin) {
      return;
    }

    const user = skin.user_id ? users[skin.user_id] : undefined;

    return <Card skin={skin} user={user} key={`skin-${id}`} />;
  }

  return (
    <>
      <Image.PreviewGroup>
        {ids && ids.map(renderSticker)}
      </Image.PreviewGroup>
    </>
  );
}

export default _ListGrid;
